import React, { useEffect, useState } from "react";
import {
  Layout,
  Space,
  Table,
  PageHeader,
  Button,
  Card,
  Input,
  Modal
} from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined, BellOutlined,ExclamationCircleOutlined } from "@ant-design/icons";


import R2Footer from "../../../components/Footer";
import "./styles.scss";
import SettingsService from "../../../services/SettingsService";
import { useSelector } from "react-redux";
import AddReservationSlots from "./AddReservationSlots";
import Spinner from "../../../components/Layout/Spinner";
import MenuSetting from "../../../services/menuSetting";


const { Content } = Layout;
const { confirm } = Modal;


const Reservation = (props) => {

  const daysInWeek = [{ id: 1, name: "Mo",value:"Mon" }, { id: 2, name: "Tu",value:"Tue" }, { id: 3, name: "We",value:"Wed" }, { id: 4, name: "Th" ,value:"Thu"}, { id: 5, name: "Fr",value:"Fri" }, { id: 6, name: "Sa", value:"Sat" }, { id: 7, name: "Su" ,value:"Sun"}]

  const [addModalOpen, setAddModalOpen] = useState(false)
  const [isLoading, setLoading] = useState(false);

  const adminRestaurant = useSelector((state) => state.admin);
  
  const columns = [
   
   
    {
      title: "Time Slot",
      dataIndex: "name",
      key: "name",
      render: (_, record) => {
        return (
          <div style={{ display: "flex" }} >
            <div  className="name_text">
              {record?.start_time +"  to  "+ record?.end_time}
            </div>
          </div>
        );
      },
    },
    {
        title: "Days",
        dataIndex: "name",
        key: "name",
        render: (_, record) => {
          const daySlots = record?.operational_days.split(',');
          return (
            <div style={{ display: "flex" }} >
              <div  className="name_text">
              <div className="time-slots">
                            {daysInWeek.map(item =>
                              <div className={daySlots.includes(item.value)?"time-slots days":"selected-slots time-slots days"} >
                                {item.name}
                              </div>
                            )}
                          </div>
              </div>
            </div>
          );
        },
      },
      {
        title: "Table No",
        dataIndex: "name",
        key: "name",
        render: (_, record) => {
          return (
            <div style={{ display: "flex" }} >
              <div  className="name_text">
                {record.tables}
              </div>
            </div>
          );
        },
      },

  
    
   
    {
      title: "",
      render: (_, record) => {
        return (
          <div
            style={{
              display: "flex",
            }}
          >
            <>
              <EditOutlined
                onClick={(e) => {
                  e.stopPropagation();
                  setUpdateData(record)
                  setAddModalOpen(true);
                }}
              />{" "}
              <DeleteOutlined style={{ fontSize: '19px', color: 'red',marginLeft:"5px" }}
              onClick={(e)=>{
                e.stopPropagation();
                handleDelete(record.id)
              
              }}/>
            </>
          </div>
        );
      },
    },
  ];

  const [slots, setSlots] = useState([])
  const [updateData, setUpdateData] = useState()
  const [settingsList, setSettingsList ] = useState();

  useEffect(()=>{
    getReservationSlots();

  },[])

  const getReservationSlots = async()=>{
    setLoading(true)
    const data = await SettingsService.getReservationSlots(adminRestaurant)
    setSlots(data?.reservation_slots)  
    setLoading(false)  
  }

  const handleDelete = (record) => {
    confirm({
      title: 'Are you sure to delete?',
      icon: <ExclamationCircleOutlined />,
      content: ' This action cannot be undone.',
  
      onOk() {
        deleteSlots(record)
      },
  
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  const deleteSlots = async(id)=>{
    const data = await SettingsService.deleteReservationSlots(adminRestaurant,id)
    getReservationSlots()  
  }
  const addSlots = () =>{
    setAddModalOpen(false)
    getReservationSlots()
  }

  useEffect(()=>{
    MenuSetting.getRestaurentSettings().then((res)=>{
        if(res?.restaurant_id){
            setSettingsList(res);
        } 
    });
}, []);
 
  const updateSettings = async(event,key)=>{
    const payload ={
      [key]: Number(event.target.value)
    }
    setSettingsList({...settingsList,
      [key]: Number(event.target.value)

    })
    const data = await SettingsService.updateTimezone(payload)
  }
  
  return (
    <Layout className="u-page-layout">
      <Content className="page-padding">
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <PageHeader
            title="Reservation Settings"
            className="page-header"
            style={{ background: "#f0f2f5" }}
          />
          <div>
        
           <Card>
            <div className="reservation-seetings">
                Reservation canceled after (if no show) : 
                 <Input className="slots-input" 
                 value={settingsList?.reservation_no_show_mins}
                 onChange={(event) =>
                  updateSettings(event, "reservation_no_show_mins")
                }
                   type="number" suffix="min" onc/>
            </div>
            <div className="reservation-seetings"> 
                How long out can booking be made :  
                <Input className="slots-input"  type="number" 
                value={settingsList?.reservation_booking_duration_days} 
                onChange={(event) =>
                  updateSettings(event, "reservation_booking_duration_days")
                }
                suffix="Days" />
            </div>
           
                <div style={{textAlign:"right"}}>
                   <Button type="primary"  className="addparties-btn"
                    onClick={(e) => {
                        e.stopPropagation();
                        setUpdateData()
                        setAddModalOpen(true)
                      }}>
      Add Reservation Slot
    </Button>
              
              </div>,
            
          
            <Table
            columns={columns}
            dataSource={slots}
            className="discount-table waitlist-table overflow-auto"
          />
           </Card>


          </div>
        </Space>
        {isLoading && <Spinner/>}
        {addModalOpen &&
        <AddReservationSlots
        modalOpen = {addModalOpen}
        closeModal = {setAddModalOpen}
        addSlots = {addSlots}
        updateData = {updateData}/>
}
      </Content>
      <R2Footer />
    </Layout>
  );
};


export default Reservation;
